import React, {
  FunctionComponent,
  useEffect,
  useState,
} from 'react';

import Wrap from '../../components/containers/Wrap';
import Modal from '../../components/Modal';
import Bodycopy from '../../components/text-components/Bodycopy';
import Title from '../../components/text-components/Title';
import PublicLayout from '../../layout/PublicLayout';
import useFAQs from '../../services/use-faq';
import { FAQAttributes } from '../../store/model/contact/types';
import t from '../../text-strings';
import AccordionHTML from '../../components/AccordionHTML';
import Content from '../../layout/components/Content';
import images from '../../assets/images';

const Stats: FunctionComponent = () => {
  const [loading, faqs] = useFAQs('Informacion');
  const [currentFaqs, setCurrentFaqs] = useState<FAQAttributes[]>([]);
  const [open, setOpen] = useState(false);

  const toggleOpen = (): void => setOpen(!open);

  useEffect(() => setCurrentFaqs(faqs), [loading]);

  const getTitle = (id: number) => currentFaqs.find((cq) => cq.questionId === id)?.title ?? 'Cargando...';
  const getContent = (id: number) => currentFaqs.find((cq) => cq.questionId === id)?.text ?? 'Cargando...';

  return (
    <PublicLayout title={t('common.navigation.contacto')}>
      <Wrap size="wrap" className="lg:flex py-16 lg:py-36">
        <div className="lg:flex-1 lg:ml-16">
          <Title className="mb-16">Energía y personas</Title>
          <div id="altas" className="w-full lg:flex lg:flex-col lg:items-center pt-16">
            <Content className="max-w-screen-xl">
              <div
                className="has-bg-image relative h-96 sm:h-128 md:h-144 rounded-base lg:h-152 flex flex-col"
                style={{ backgroundImage: `url(${images.energiaYPersonas})`, marginBottom: '2rem', backgroundPosition: 'bottom' }}
              />
            </Content>
          </div>
          <Bodycopy>
            El sector de la energía está cambiando y esto nos afecta a todos. Y en Cuerva, estamos
            aquí para acompañarte a redescubrir tu energía.
            <br />
            Energía y personas es ese espacio en el que encontrarás información acerca del
            funcionamiento actual del sector energético para mejorar la comprensión sobre este y
            hacer la energía más fácil para las personas de futuro.
          </Bodycopy>
          <br />

          { !loading
          && (
          <>
            {currentFaqs.find((f) => f.questionId === 76) && (<Title className="mb-16">Conocimiento compartido</Title>)}
            {currentFaqs.find((f) => f.questionId === 76) && (
            <AccordionHTML
              key={76}
              title={getTitle(76)}
              html={getContent(76)}
            />
            ) }
            <br />
            {(currentFaqs.filter((f) => f.questionId === 77 || f.questionId === 78).length > 0) && (
            <>
              <Title className="mb-16">Recursos gratuitos</Title>
              {currentFaqs.find((f) => f.questionId === 77) && (
              <AccordionHTML
                key={77}
                title={getTitle(77)}
                html={getContent(77)}
              />
              )}
              {currentFaqs.find((f) => f.questionId === 78) && (
              <AccordionHTML
                key={78}
                title={getTitle(78)}
                html={getContent(78)}
              />
              )}
            </>
            )}
          </>
          )}

        </div>
        <Modal isOpen={open} toggleOpen={toggleOpen}>
          <Title size="small" className="mb-12">
            {t('contact.llamanos')}
          </Title>
          <Bodycopy className="mb-8">{t('contact.averias')}</Bodycopy>
          <Title className="text-blue mb-4">900 37 38 13</Title>
          <Bodycopy className="mb-24">{t('contact.24h')}</Bodycopy>
          <Bodycopy className="mb-8">{t('contact.otras')}</Bodycopy>
          <Title className="text-blue mb-4">958 570 360</Title>
          <Bodycopy className="mb-2">{t('contact.horario')}</Bodycopy>
          <Bodycopy className="mb-24">{t('contact.estacional')}</Bodycopy>
        </Modal>
      </Wrap>
    </PublicLayout>
  );
};

export default Stats;
